var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 80C15 44.1 44.1 15 80 15C115.9 15 145 44.1 145 80C145 115.9 115.9 145 80 145C44.1 145 15 115.9 15 80ZM104.067 67.9067C104.467 67.3737 104.756 66.7661 104.918 66.1197C105.08 65.4732 105.111 64.8009 105.009 64.1424C104.907 63.4838 104.675 62.8522 104.326 62.2846C103.976 61.7171 103.517 61.2252 102.975 60.8377C102.433 60.4502 101.819 60.1749 101.169 60.0282C100.519 59.8814 99.8459 59.8661 99.1898 59.9831C98.5338 60.1001 97.9078 60.347 97.3485 60.7094C96.7893 61.0718 96.3081 61.5423 95.9333 62.0933L74.36 92.2933L63.5333 81.4667C62.5855 80.5835 61.3319 80.1026 60.0365 80.1255C58.7412 80.1484 57.5053 80.6731 56.5892 81.5892C55.6731 82.5053 55.1483 83.7412 55.1255 85.0365C55.1026 86.3319 55.5835 87.5855 56.4667 88.5333L71.4667 103.533C71.9799 104.046 72.5987 104.441 73.2799 104.691C73.9612 104.941 74.6886 105.039 75.4118 104.98C76.1349 104.92 76.8364 104.704 77.4675 104.346C78.0987 103.988 78.6443 103.497 79.0667 102.907L104.067 67.9067Z",
    fill: "#81E1CE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.b4ba0a8daa915eb9fc3cafaed26e8cd0.svg";
export { ForwardRef as ReactComponent };